var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import guide from '../../../components/fund/loan-manage/create-order-guide.vue';
import list from '../../../components/fund/loan-manage/list.vue';
export default Vue.extend({
    name: 'fundLoanOrder',
    components: {
        'el-guide': guide,
        'el-list': list,
    },
    computed: __assign({}, mapState('fundLoanManage', {
        isLoanOrder: 'isLoanOrder',
    })),
    data: function () {
        return {};
    },
    created: function () {
        this.$store.dispatch('fundLoanManage/IS_LOAN_ORDER'); // TODO:判断是否存在放款订单
    },
    methods: {},
});
